import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DiscountTemplatesService } from '../discount-templates.service';
import { ControlItem, ProductTypesEnum } from 'src/app/models/frontend';
import { ProductType } from 'src/app/models/enums';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-create-product-custmized-discount-templates',
  templateUrl: './create-product-custmized-discount-templates.component.html',
  styleUrls: ['./create-product-custmized-discount-templates.component.scss']
})
export class CreateProductCustmizedDiscountTemplatesComponent {
  @ViewChild('allDiscounts') discountsInput!: ElementRef<HTMLInputElement>; 
  errors: string[] | null = [];
  eventForm: FormGroup
  @ViewChild('modal') modal: ElementRef;

  productType: 3;

  productOption: ControlItem[] = []

  CountryIso: any = "US"
  ProviderCode: any
  loader=false;
  Products: any
  ProductId:any
  ProductName:any
  ProductSKU:any
  ID: number
  constructor(public activatedRoute: ActivatedRoute,
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    public productSerivce: DiscountTemplatesService,
    public router: Router,private toastr:ToastrService) {
    // this.productType = ProductTypesEnum
    this.activatedRoute.params.subscribe(params => { this.ID = params['id'].replace('id', '') });
    this.GetActiveProducts()
  }

  GetActiveProducts(){
    this.productSerivce.GetActiveProducts().subscribe((res:any)=>{
      this.Products=res;
      console.log(this.Products)
      for (let i = 0; i <= this.Products.length; i++) {
        console.log(this.Products[i].id)
        this.productOption.push({ value: i+1, label: this.Products[i].productName, label2:this.Products[i].sku})
      }
    })
  }
  GetProduct(id) {
    console.log(id.value)
    console.log(this.productOption)
    this.ProductId = id.value
    var selected = this.productOption[id.value-1];
    console.log(selected)
    this.ProductName=selected.label
    this.ProductSKU=selected.label2
    console.log(selected)
    
  }
  closeModal() {
    this.activeModal.close({ refresh: true });
    }
  onSubmit(discount){
    this.loader=true;
    console.log(this.productSerivce.templateId)
    // const productTypeNumber = parseInt(, 10);
    const productIdNumber = parseInt(this.ProductId, 10);
    const discountValue = parseInt(discount, 10);
    const templateId = parseInt(this.productSerivce.templateId, 10);

    this.eventForm = this.fb.group({
      ProductType: ProductType.PridExpress,
      ProductId: productIdNumber,
      ProductTitle:this.ProductName,
      SkuCode: this.ProductSKU,
      DiscountPercentage: discountValue,
      DiscountTemplateId:templateId,
      IsActive:true,
      amount: 0,
      prideComissionPercentage: 0,
      prideProfitPercentage: 0,
    })
    console.log(this.eventForm.value)
    this.productSerivce.CreateDiscountTemplateCustomized(this.eventForm.value).
    subscribe({
      next: r => {
        // Swal.fire('Created', '', 'success')
        if(this.discountsInput)
          this.discountsInput.nativeElement.value='';

        this.toastr.success('Created','Success');
        // this.activeModal.close({ refresh: true });
      },
      error: e => {
        if (e.error.message) {
          this.toastr.error('Oops!', e.error.message);
        }
        else {
          this.toastr.error('Oops!', "Something went wrong");
        }
      },
      complete:()=>{
        this.loader=false;
      }
    })
  }
}
